"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuspendedAmountServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
const base = (companyId, shareholderId) => `/company/${companyId}/shareholders/${shareholderId}`;
class SuspendedAmountServiceLive {
    async getSuspendedAmounts(companyId, shareholderId) {
        const response = await HttpProvider_1.httpProvider.get(`${base(companyId, shareholderId)}/suspended-amounts`);
        return response.data;
    }
    async clearSuspendedAmounts(companyId, shareholderId, paymentDate) {
        const response = await HttpProvider_1.httpProvider.post(`${base(companyId, shareholderId)}/suspended-amounts/clear`, {
            paymentDate,
        });
        return response.data;
    }
    async getSuspendedSettlements(companyId, shareholderId) {
        const response = await HttpProvider_1.httpProvider.get(`${base(companyId, shareholderId)}/suspended-settlements`);
        return response.data;
    }
    async getSuspendedSettlementStatement(companyId, shareholderId, settlementId) {
        const response = await HttpProvider_1.httpProvider.get(`${base(companyId, shareholderId)}/suspended-settlements/${settlementId}/statement`);
        return response.data;
    }
    async getSuspendedSettlementAbaFile(companyId, shareholderId, settlementId) {
        const response = await HttpProvider_1.httpProvider.get(`${base(companyId, shareholderId)}/suspended-settlements/${settlementId}/aba`);
        return response.data;
    }
}
exports.SuspendedAmountServiceLive = SuspendedAmountServiceLive;
//# sourceMappingURL=SuspendedAmountServiceLive.js.map